var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-button-group',{staticClass:"float-right"},[(_vm.$temAcessoView('CRED-FORN-FIN-01'))?_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.confirmarNovaFinalizacao()}}},[_vm._v("Novo Registro de Pagamento")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }